module.exports = __webpack_public_path__ + "img/04-3-4管理面板.9ebab35c.svg";